import styled from 'styled-components';
import { Image } from 'semantic-ui-react';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
  padding-top: 84px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const StyledImage = styled(Image)`
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  margin-top: 0;
  margin-bottom: 8px;
  font: inherit;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  color: ${theme.colors.secondary900};
`;

export const Tip = styled.p`
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.colors.secondary800};
`;
